export default "__VITE_ASSET__0d66e9bc__"